'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function canUseWebp() {
  if ((typeof document === 'undefined' ? 'undefined' : (0, _typeof3.default)(document)) !== 'object') {
    return false;
  }
  var canvas = document.createElement('canvas');
  if (!canvas.getContext || !canvas.getContext('2d')) {
    return false;
  }
  return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
}
var Picture = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Picture, _Component);

  function Picture(props) {
    (0, _classCallCheck3.default)(this, Picture);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Picture.__proto__ || (0, _getPrototypeOf2.default)(Picture)).call(this, props));

    _this.useWebp = canUseWebp();
    return _this;
  }

  (0, _createClass3.default)(Picture, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          srcWebp = _props.srcWebp,
          srcJpg = _props.srcJpg,
          src = _props.src,
          alt = _props.alt,
          className = _props.className;


      return _react2.default.createElement('img', {
        className: className,
        src: this.useWebp && srcWebp || srcJpg || src,
        alt: alt
      });
    }
  }]);
  return Picture;
}(_react.Component), _class.propTypes = {
  // @data
  className: _react.PropTypes.string,
  srcWebp: _react.PropTypes.string,
  srcJpg: _react.PropTypes.string,
  src: _react.PropTypes.string,
  alt: _react.PropTypes.string
}, _temp);
exports.default = Picture;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Picture.js
// module id = 1517
// module chunks = 0